export default "__VITE_ASSET__Briqy694__"